module.exports = __webpack_public_path__ + "static/media/faccia_05.b76a4f63.png";